var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.875,
    y: 0.875,
    width: 82.25,
    height: 82.25,
    rx: 41.125,
    stroke: "white",
    strokeWidth: 1.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 59.5L42 42M42 42L59.5 24.5M42 42L24.5 24.5M42 42L59.5 59.5",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelModal);
export default __webpack_public_path__ + "static/media/cancelModal.5ef3c767cd4c9912b06472cfea4dbe6f.svg";
export { ForwardRef as ReactComponent };